// extracted by mini-css-extract-plugin
export default {"externalReviews":"thumbnail_externalReviews__a6uFU","externalReviewsSite":"thumbnail_externalReviewsSite__2-1BL","image":"thumbnail_image__0NZ7Y","dot":"thumbnail_dot__iANGy"};